import Button from '@mui/material/Button';

const BetaSiteCookieButton = (props) => {

    const buttonLabel = props.UseBetaSiteCookie ? 'Remove Beta Site Cookie' : 'Use Beta Site Cookie'; 

    return (
        <div className='use-beta-site-cookie'>
            <Button size="small" sx={{ boxShadow: "none" }} className='use-beta-site-cookie-button' onClick={props.ToggleBetaSiteCookie} title={buttonLabel}>{buttonLabel}</Button>
        </div>
    );
}

export default BetaSiteCookieButton;